import React, { useState, ChangeEvent, FormEvent } from 'react';
import { Redirect } from 'react-router-dom';
import { IconButton, FormControl, InputBase, InputAdornment, InputLabel, makeStyles } from '@material-ui/core';

import { ReactComponent as SearchIcon } from 'assets/icons/search-icon.svg';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  input: {
    zIndex: 5,
    width: '50vw',
    height: '54px',
    borderRadius: '100vh',
    backgroundColor: palette.secondary.light,
    padding: '12px 0 12px 20px',
    [breakpoints.up('md')]: {
      width: '15vw',
      marginRight: '10px',
    },
    '& .MuiInputBase-input': {
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
      },
    },
  },
}));

const IDSearch = () => {
  const classes = useStyles();

  const [userInput, setUserInput] = useState('');
  const [redirect, setRedirect] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => setUserInput(e.target.value);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (userInput.length > 4) setRedirect(true);
  };

  if (redirect) return <Redirect to={`/location/${userInput}`} />;

  return (
    <form onSubmit={handleSubmit}>
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel htmlFor="location_id">Location ID</InputLabel>
        <InputBase
          id="location_id"
          type="number"
          value={userInput}
          onChange={handleChange}
          endAdornment={
            <InputAdornment position="end">
              <IconButton type="submit" aria-label="submit">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </form>
  );
};

export default IDSearch;
